import React, { useEffect } from "react";
import TimeIcon from "assets/svgIcons/TimeIcon";
import PinPositionIcon from "assets/svgIcons/AdminDashboard/PinPosition";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { COMMON_SERVICES } from "../../../../redux/reduxToolkitServices/_commonServices/commonServices";
import { useTranslation } from "react-i18next";
import { API_STATUSES } from "redux/_helpers/statuses";
import { SITEID_GLOBAL_STATE } from "globalStore/globalStore";
import { useHookstate } from "@hookstate/core";
import EzlocatorIcon from "assets/images/ezLocator_logo.png";

export const PinPosition = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);
  const {
    getTodayPinPositionDataReduxState,
    getDashboardFeatureSetStatus,
    greensWithPinPlacementStateData
  } = useSelector((state) => state.commonReducers);

  useEffect(() => {
    if (getDashboardFeatureSetStatus === API_STATUSES.SUCCESS) {
      dispatch(
        COMMON_SERVICES.getTodayPinPositionServices(
          localStorage.getItem("dashCourseId"),
          siteId.get()
        )
      );
    }
    dispatch(COMMON_SERVICES.getGreensWithPinPlacementsServices(siteId.get()));
  }, [
    getDashboardFeatureSetStatus,
    siteId.get(),
    localStorage.getItem("dashCourseId"),
  ]);
  const ezLocator = greensWithPinPlacementStateData && greensWithPinPlacementStateData.EzLocatorCourse;
  return (
    <>
      <div className="header">
        <TimeIcon color="#000" width={25} height={20} />
        <p className="green-border">{t("Todays_Pin_Position")}</p>
      </div>
      {!(ezLocator) && <div className="box-body">
        <PinPositionIcon />
        <h2 className="bp-heading">
          {getTodayPinPositionDataReduxState !== "" ? (
            getTodayPinPositionDataReduxState
          ) : (
            <span className="text-12">{t("Center_of_Green")}</span>
          )}
        </h2>
        <p className="bp-sub-heading">{t("Pin_position")}</p>
      </div>}
      {(ezLocator) && <a
        className="box-body"
        rel="noopener noreferrer"
        href="https://www.pinsheet.com/"
        target="_blank"
      >
        <img style={{ width: "180px", height: "100px" }} src={EzlocatorIcon} alt="EzlocatorIcon" />
      </a>}
    </>
  );
};
